import { render } from "./MeSciFi.vue?vue&type=template&id=7098502b&scoped=true"
import script from "./MeSciFi.vue?vue&type=script&lang=js"
export * from "./MeSciFi.vue?vue&type=script&lang=js"

import "./MeSciFi.vue?vue&type=style&index=0&id=7098502b&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7098502b"]])

export default __exports__